// HeaderHelpMenu.js - Compact "?" header menu (App guide, Support), shown in
// the wide right cluster. In the compact right cluster these two items move
// into HeaderProfileMenu's Help section instead.

import React, { useState } from "react";

import HeaderDropdown, { HeaderMenuItem } from "./HeaderDropdown";
import HeaderIconButton from "./HeaderIconButton";

export default function HeaderHelpMenu({ isDarkMode, onAppGuide, onSupport, t = (s) => s }) {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  const withClose = (handler) => () => {
    if (handler) handler();
    close();
  };

  const trigger = (
    <HeaderIconButton
      icon="help-circle-outline"
      label={t("Help")}
      active={open}
      accessibilityState={{ expanded: open }}
      onPress={() => setOpen((prev) => !prev)}
      testID="help-menu-trigger"
    />
  );

  return (
    <HeaderDropdown
      open={open}
      onClose={close}
      isDarkMode={isDarkMode}
      align="right"
      width={220}
      trigger={trigger}
      testID="help-menu"
    >
      <HeaderMenuItem
        isDarkMode={isDarkMode}
        icon="book-open-page-variant"
        label={t("App guide")}
        onPress={withClose(onAppGuide)}
        testID="help-menu-app-guide"
      />
      <HeaderMenuItem
        isDarkMode={isDarkMode}
        icon="lifebuoy"
        label={t("Support")}
        onPress={withClose(onSupport)}
        testID="help-menu-support"
      />
    </HeaderDropdown>
  );
}
